// Routes.jsx
import { useRoutes } from 'react-router-dom';
import Home from './pages/Home';
import UsersFaq from './pages/FAQs/UserFAQs/Faq'
import WhitelabelsFaq from './pages/FAQs/WhitelabelFAQs/Faq'
import { NotFound } from './pages/NotFound';
import MaintenancePage from './pages/MaintenancePage';
import MerchantPolicy from './pages/GDPR/MerchantPolicy';
import MerchantTermsConditions from './pages/GDPR/MerchantTermsConditions';
import MerchantSecurity from './pages/GDPR/MerchantSecurity';
import CustomerPolicy from './pages/GDPR/CustomerPolicy';
import CustomerTermsConditions from './pages/GDPR/CustomerTermsConditions';
import CustomerSecurity from './pages/GDPR/CustomerSecurity';
import WLPolicy from './pages/GDPR/WLPolicy';
import WLTermsConditions from './pages/GDPR/WLTermsConditions';
import WLSecurity from './pages/GDPR/WLSecurity';
import DeveloperDocuments from './pages/DeveloperDocuments/home';

const AppRoutes = () => {
  const routes = useRoutes([
    { path: '/', element: <Home /> },
    { path: '/user_faqs', element: <UsersFaq /> },
    { path: '/whitelabels_faqs', element: <WhitelabelsFaq /> },
    { path: '/404', element: <NotFound /> },
    { path: '*', element: <NotFound /> },
    { path: '/maintenece_mode', element: <MaintenancePage /> },
    { path: '/merchant_policy', element: <MerchantPolicy /> },
    { path: '/merchant_terms_conditions', element: <MerchantTermsConditions /> },
    { path: '/merchant_security', element: <MerchantSecurity /> },
    { path: '/customer_policy', element: <CustomerPolicy /> },
    { path: '/customer_terms_conditions', element: <CustomerTermsConditions /> },
    { path: '/customer_security', element: <CustomerSecurity /> },
    { path: '/wl_policy', element: <WLPolicy /> },
    { path: '/wl_terms_conditions', element: <WLTermsConditions /> },
    { path: '/wl_security', element: <WLSecurity /> },
    { path: '/developer-portal', element: <DeveloperDocuments /> }
  ]);

  return routes;
};

export default AppRoutes;
